//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, defineComponent, ref, toRefs, watch } from "@vue/composition-api";
import { useApplicationStoreGetters, useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as LenderSubmitGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import * as LenderSubmitActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import CommissionDeduction from "./commission-deduction.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "CommissionDeductions",
  components: {
    CommissionDeduction
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    currentCommissionsMortgageType: {
      type: String,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      tc
    } = useI18n();
    const columnHeaders = ref([{
      label: tc("direct-to-lender.commissions.deductions.deductionType"),
      size: "col-3"
    }, {
      label: tc("global.words.amount"),
      size: "col-2"
    }, {
      label: tc("direct-to-lender.commissions.deductions.fundsReceived"),
      size: "col-3"
    }]);
    const {
      GET_COMMISSION_DEDUCTIONS
    } = useApplicationStoreGetters([LenderSubmitGetters.GET_COMMISSION_DEDUCTIONS]);
    const commissionDeductions = computed(() => GET_COMMISSION_DEDUCTIONS.value(applicationId.value));
    const {
      clientUsername,
      applicationId,
      currentCommissionsMortgageType
    } = toRefs(props);
    const currentCommissionsFeesMortgageType = computed(() => currentCommissionsMortgageType.value);
    const {
      CREATE_COMMISSION_DEDUCTION,
      SAVE_COMMISSION_DEDUCTION,
      REMOVE_COMMISSION_DEDUCTION
    } = useApplicationStoreActions([LenderSubmitActions.CREATE_COMMISSION_DEDUCTION, LenderSubmitActions.SAVE_COMMISSION_DEDUCTION, LenderSubmitActions.REMOVE_COMMISSION_DEDUCTION]);
    const handleAdd = () => {
      CREATE_COMMISSION_DEDUCTION({
        clientUsername: clientUsername.value,
        applicationId: applicationId.value,
        mortgageType: currentCommissionsFeesMortgageType.value
      });
    };
    const handleSave = (commissionsDeductionId, value) => {
      SAVE_COMMISSION_DEDUCTION({
        clientUsername: clientUsername.value,
        applicationId: applicationId.value,
        mortgageType: currentCommissionsFeesMortgageType.value,
        commissionsDeductionId,
        deduction: value
      });
    };
    const handleRemove = commissionsDeductionId => {
      REMOVE_COMMISSION_DEDUCTION({
        clientUsername: clientUsername.value,
        applicationId: applicationId.value,
        commissionsDeductionId
      });
    };
    watch(currentCommissionsFeesMortgageType, value => {
      emit("update", value);
    });
    return {
      // data properties
      columnHeaders,
      // computed properties
      commissionDeductions,
      // methods
      handleAdd,
      handleSave,
      handleRemove
    };
  }
});